/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_LoadingInputs */

const en_us2_draft_loading = /** @type {(inputs: Draft_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading the draft…`)
};

const pt_br2_draft_loading = /** @type {(inputs: Draft_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando o rascunho…`)
};

const es_419_draft_loading = /** @type {(inputs: Draft_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando el borrador…`)
};

const pt_pt2_draft_loading = /** @type {(inputs: Draft_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar o rascunho…`)
};

const fr_fr2_draft_loading = /** @type {(inputs: Draft_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement du brouillon…`)
};

const de_de2_draft_loading = /** @type {(inputs: Draft_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwurf wird geladen…`)
};

const it_it2_draft_loading = /** @type {(inputs: Draft_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento della bozza…`)
};

/**
* | output |
* | --- |
* | "Loading the draft…" |
*
* @param {Draft_LoadingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_loading = /** @type {((inputs?: Draft_LoadingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_LoadingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_loading(inputs)
	if (locale === "es-419") return es_419_draft_loading(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_loading(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_loading(inputs)
	if (locale === "de-DE") return de_de2_draft_loading(inputs)
	if (locale === "it-IT") return it_it2_draft_loading(inputs)
	return en_us2_draft_loading(inputs)
});
export { draft_loading as "draft.loading" }